import {ActivityList} from "./ActivityList";
import {ActivityEdit} from "./ActivityEdit";
import {ActivityCreate} from "./ActivityCreate";

export default {
    list: ActivityList,
    create: ActivityCreate,
    edit: ActivityEdit
};
